import { paperStyles } from '@festina-life/ui/libs'
import cx from 'classnames'

import { NavigationTab } from './NavigationTab'
import { NavigationTabsOptions } from './NavigationTabsOptions'
import { useTabNavigation } from './useTabNavigation'

export const NavigationTabsBar = () => {
  const { close, tabLinks, closeAll, closeInactive } = useTabNavigation()

  return (
    <div
      className={cx(
        'flex w-full flex-row',
        paperStyles({ isFaded: false, borders: ['bottom'] }),
      )}
    >
      <div className="flex grow flex-row flex-wrap">
        {tabLinks?.map((tabLink) => (
          <NavigationTab
            key={`${tabLink.id}-${tabLink.variant}-${tabLink.block}-${tabLink.layer.layerId}-${tabLink.layer.tenantId}`}
            link={tabLink}
            onClose={() => close(tabLink)}
          />
        ))}
      </div>
      <NavigationTabsOptions
        onCloseInactive={closeInactive}
        onCloseAll={closeAll}
      />
    </div>
  )
}
